import { render, staticRenderFns } from "./pack.vue?vue&type=template&id=234c384c&scoped=true"
import script from "./pack.vue?vue&type=script&lang=ts"
export * from "./pack.vue?vue&type=script&lang=ts"
import style0 from "./pack.vue?vue&type=style&index=0&id=234c384c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c384c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234c384c')) {
      api.createRecord('234c384c', component.options)
    } else {
      api.reload('234c384c', component.options)
    }
    module.hot.accept("./pack.vue?vue&type=template&id=234c384c&scoped=true", function () {
      api.rerender('234c384c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/stockout/pack.vue"
export default component.exports